import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [username, setUsername] = useState("medaillon");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) {
      setError("Le mot de passe est requis");
      return;
    }

    const token = btoa(`${username}:${password}`);
    localStorage.setItem("admin_token", token);
    
    // On essaie de faire un appel simple pour valider
    window.location.href = "/";
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "80vh",
      fontFamily: "sans-serif"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "400px",
        padding: "40px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "white"
      }}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <img src="/logo-medaillon.png" alt="Médaillon" style={{ height: "50px", marginBottom: "10px" }} />
          <h2 style={{ margin: 0, color: "#333" }}>Accès Admin</h2>
        </div>

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label htmlFor="username" style={{ fontSize: "14px", fontWeight: "bold", color: "#666" }}>Utilisateur</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                fontSize: "16px"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label htmlFor="password" style={{ fontSize: "14px", fontWeight: "bold", color: "#666" }}>Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoFocus
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                fontSize: "16px"
              }}
            />
          </div>

          {error && <div style={{ color: "#f2513c", fontSize: "14px" }}>{error}</div>}

          <button
            type="submit"
            style={{
              padding: "12px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#2098ae",
              color: "white",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: "10px"
            }}
          >
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
